import payment from './API/payment';
import stationList from './API/stationList';
import rental from './API/rental';
import station from './API/station'
import other from './API/other';
import user from './API/user';

export default {
    payment,
    stationList,
    rental,
    station,
    other,
    user
}